const variantChangeActions = () => {
  document.addEventListener("DOMContentLoaded", async () => {
    // Preorder Messageの表示
    const firstAdditionalMessageElement = document.querySelectorAll(
      ".additional_message"
    );
    if (firstAdditionalMessageElement) {
      const firstAdditionalMessageArray = Array.from(
        document.querySelectorAll(".additional_message")
      );

      firstAdditionalMessageArray.forEach((element) => {
        let firstAdditionalMessage = element.textContent;
        if (firstAdditionalMessage) {
          const formStyle = document.querySelector("#buy-button-section");
          if (formStyle) {
            formStyle.style.setProperty("--product-info-gap", "1rem");
          }
        }
      });
    }

    // Alert Messageの表示
    const firstAlertMessageElement =
      document.querySelectorAll(".alert_message");
    if (firstAlertMessageElement) {
      const firstAlertMessageArray = Array.from(
        document.querySelectorAll(".alert_message")
      );

      firstAlertMessageArray.forEach((element) => {
        let firstAlertMessage = element.textContent;
        if (firstAlertMessage) {
          const formStyle = document.querySelector("#buy-button-section");
          if (formStyle) {
            formStyle.style.setProperty("--product-info-gap", "1rem");
          }
        }
      });
    }

    // 税込み価格の表示切り替え
    const compareAtPriceElement = document.querySelector("compare-at-price");
    toggleTaxElement(compareAtPriceElement);

    // GIFTCARDのラベル色変更
    const blockSwatchs = Array.from(document.querySelectorAll(".block-swatch"));
    const selecttedVariant = document.querySelector("variant-sku");

    if (blockSwatchs && selecttedVariant) {
      const selecttedVariantId = selecttedVariant.dataset.variantId;
      blockSwatchs.forEach((block) => {
        const variantId = block.dataset.variantId;
        if (selecttedVariantId == variantId) {
          block.classList.toggle("block-button-color-change");
        } else if (block.classList.contains("block-button-color-change")) {
          block.classList.toggle("block-button-color-change");
        }
      });
    }

    document.addEventListener("variant:change", function (event) {
      const variant = event.detail.variant;
      const variant_id = event.detail.variant.id;

      // Preorder Messageの表示
      const preOrderMessageElement = document.querySelector(
        `#preOrderMessage-${variant_id}`
      );
      let additionalMessageElement = document.querySelectorAll(
        ".additional_message"
      );

      if (preOrderMessageElement) {
        const additionalMessageBlockArray = Array.from(
          additionalMessageElement
        );
        const preOrderMessage = preOrderMessageElement.textContent;
        const additionalMessageInputArray = Array.from(
          document.querySelectorAll(".additional_message_input")
        );

        if (preOrderMessage) {
          const formStyle = document.querySelector("#buy-button-section");
          formStyle.style.setProperty("--product-info-gap", "1rem");

          additionalMessageBlockArray.forEach((element) => {
            element.innerHTML = preOrderMessage;
            element.style.color = "#B5262B";
          });
          additionalMessageInputArray.forEach((element) => {
            element.value = preOrderMessage;
          });
        } else {
          additionalMessageBlockArray.forEach((element) => {
            element.textContent = "";
          });
          additionalMessageInputArray.forEach((element) => {
            element.value = "";
          });
        }
      }

      // Alert Messageの表示
      const alertMessageElement = document.querySelector(
        `#alertMessage-${variant_id}`
      );
      let alertMessageBlockElement =
        document.querySelectorAll(".alert_message");
      if (alertMessageElement) {
        const alertMessageBlockArray = Array.from(alertMessageBlockElement);
        const alertMessage = alertMessageElement.textContent;
        if (alertMessage && alertMessage !== "") {
          const formStyle = document.querySelector("#buy-button-section");
          formStyle.style.setProperty("--product-info-gap", "1rem");

          alertMessageBlockArray.forEach((element) => {
            element.innerHTML = alertMessage;
            element.style.color = "#B5262B";
          });
        } else {
          alertMessageBlockArray.forEach((element) => {
            element.textContent = "";
          });
        }
      }

      // 税込み価格の表示切り替え
      const compareAtPriceElement = document.querySelector("compare-at-price");
      toggleTaxElement(compareAtPriceElement);

      // GIFTCARDのラベル色変更
      const blockSwatchs = Array.from(
        document.querySelectorAll(".block-swatch")
      );
      if (blockSwatchs) {
        blockSwatchs.forEach((block) => {
          const label_title_element = block.querySelector("span");
          let label_title = "";
          if (label_title_element) {
            label_title = label_title_element.textContent;
          }
          const variant_title = variant.title;
          if (label_title == variant_title) {
            block.classList.toggle("block-button-color-change");
          } else if (block.classList.contains("block-button-color-change")) {
            block.classList.toggle("block-button-color-change");
          }
        });
      }
    });
  });
};
const toggleTaxElement = (compareAtPriceElement) => {
  if (compareAtPriceElement) {
    const priceTextContent = compareAtPriceElement.textContent;
    const taxElement = document.querySelector(".c--price-list__tax");
    const taxElement_saleprice = document.querySelector(
      ".c--price-list__tax_saleprice"
    );
    if (priceTextContent.includes("¥0") || !priceTextContent.includes("¥")) {
      taxElement.style.display = "none";
      taxElement_saleprice.style.color = "#625E58";
    } else {
      taxElement.style.display = "block";
      taxElement_saleprice.style.color = "#b5262b";
    }
  }
};

const getProductJson = async (url) => {
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok " + response.statusText);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to get product JSON:", error);
    throw new Error("Failed to get product JSON.");
  }
};

variantChangeActions();